export enum FeatureGuardMode {
  Dialog = 'dialog',
  Redirect = 'redirect',
}

export interface FeatureGuardComponent {
  mode: FeatureGuardMode;
  feature: string;
}

export enum GuardedFeature {
  AdjustableRoles = 'adjustableRoles',
  AdvancedReports = 'advancedReports',
  ReportsBuilderLaunch = 'reportsBuilderLaunch',
  ReportsBuilderScale = 'reportsBuilderScale',
  ReportsBuilderLead = 'reportsBuilderLead',
  AutomatedActions = 'automatedActions',
  CustomDomain = 'customDomain',
  DefaultProfileFields = 'defaultProfileFields',
  EEO = 'EEO',
  EvaluationForms = 'evaluationForms',
  Multilang = 'multilang',
  OverdueCandidates = 'overdueCandidates',
  Pipelines = 'pipelines',
  Questionnaires = 'questionnaires',
  Referrals = 'referrals',
  SSO = 'sso',
  Scheduler = 'scheduler',
  OpenQuestions = 'openQuestions',
  SendLater = 'sendLater',
  SourcingExtension = 'sourcingExtension',
  Visibility = 'visibility',
  EventInvitationEmails = 'eventInvitationEmails',
  GDPRAutomations = 'gdprAutomations',
  Webhooks = 'webhooks',
  MeetingRooms = 'meetingRooms',
  JobScheduler = 'jobScheduler',
  ProfilePrint = 'profilePrint',
  Security = 'security',
  AuditLogs = 'auditLogs',
  FairEvaluations = 'fairEvaluations',
  NotificationsPerRole = 'notificationsPerRole',
  KnockoutQuestions = 'knockoutQuestions',
  Requisitions = 'requisitions',
  DarkMode = 'darkMode',
}
